import { render, staticRenderFns } from "./b_school_management.vue?vue&type=template&id=4a36f457&"
import script from "./b_school_management.vue?vue&type=script&lang=js&"
export * from "./b_school_management.vue?vue&type=script&lang=js&"
import style0 from "./b_school_management.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports